var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { height: "40px" } },
        [
          _c("van-nav-bar", {
            attrs: {
              "left-arrow": "",
              title: "搜索配方",
              fixed: "",
              "safe-area-inset-top": "",
            },
            on: { "click-left": _vm.onClickLeft },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "div-box" }, [
        _c(
          "div",
          { staticClass: "div-nav" },
          [
            _c(
              "van-row",
              { staticStyle: { border: "solid 1px #fff", height: "35px" } },
              [
                _c(
                  "van-col",
                  {
                    staticStyle: { border: "solid 1px #fff" },
                    attrs: { span: "19" },
                  },
                  [
                    _c("van-cell-group", { attrs: { inset: "" } }, [
                      _c(
                        "form",
                        {
                          attrs: { action: "javascript:return true" },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.formSubmit.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("van-field", {
                            ref: "inputText",
                            staticClass: "search_in",
                            attrs: {
                              "left-icon": "search",
                              type: "search",
                              placeholder: "搜索“丰田 凯美瑞 089 铂金珍珠白”",
                            },
                            on: {
                              input: _vm.searchVlaInput,
                              blur: _vm.searchVlaBlur,
                              focus: _vm.searchVlaFocus,
                              keydown: function ($event) {
                                return _vm.handleKeyUp($event)
                              },
                            },
                            model: {
                              value: _vm.searchVla,
                              callback: function ($$v) {
                                _vm.searchVla = $$v
                              },
                              expression: "searchVla",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
                _c("van-col", { attrs: { span: "5" } }, [
                  _c(
                    "div",
                    {
                      staticClass: "sea-inpt-div",
                      on: { click: _vm.screenClick },
                    },
                    [
                      _c("van-icon", {
                        staticClass: "sea-inpt-siz",
                        attrs: { size: "1rem", name: "bars" },
                      }),
                      _c("span", { staticClass: "sea-inpt-siz" }, [
                        _vm._v("筛选"),
                      ]),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.searchShowDiv,
                    expression: "!searchShowDiv",
                  },
                ],
                staticClass: "sort-style",
              },
              [
                _c(
                  "div",
                  { staticStyle: { "margin-left": "20px" } },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "iconDivT",
                        on: { click: _vm.triangleClick },
                      },
                      [_vm._v(_vm._s(_vm.firstText))]
                    ),
                    _c("div", {
                      staticClass: "iconDiv",
                      staticStyle: { width: "12px" },
                    }),
                    _c("van-icon", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.triangle,
                          expression: "triangle",
                        },
                      ],
                      staticClass: "iconX",
                      attrs: { name: "arrow-down" },
                      on: { click: _vm.triangleClick },
                    }),
                    _c("van-icon", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.triangle,
                          expression: "!triangle",
                        },
                      ],
                      staticClass: "iconS",
                      attrs: { name: "arrow-up" },
                      on: { click: _vm.triangleClick },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "up-style" }, [
                  _c("div", { staticClass: "iconDiv" }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.queryPageData.data.sort == "desc",
                          expression: "queryPageData.data.sort=='desc'",
                        },
                      ],
                      staticStyle: { "margin-top": "7px" },
                    },
                    [_vm._v("由高到低")]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.queryPageData.data.sort == "asc",
                          expression: "queryPageData.data.sort=='asc'",
                        },
                      ],
                      staticStyle: { "margin-top": "7px" },
                    },
                    [_vm._v("由低到高")]
                  ),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.queryPageData.data.sort == "desc",
                        expression: "queryPageData.data.sort=='desc'",
                      },
                    ],
                    staticClass: "icon-img",
                    staticStyle: { "margin-right": "22px" },
                    attrs: {
                      src: require("../assets/image/below.png"),
                      alt: "",
                    },
                    on: { click: _vm.sortImgClick },
                  }),
                  _c("img", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.queryPageData.data.sort == "asc",
                        expression: "queryPageData.data.sort=='asc'",
                      },
                    ],
                    staticClass: "icon-img",
                    staticStyle: { "margin-right": "22px" },
                    attrs: { src: require("../assets/image/up.png"), alt: "" },
                    on: { click: _vm.sortImgClick },
                  }),
                  _c("div", {
                    staticClass: "iconDiv",
                    staticStyle: { width: "2px" },
                  }),
                ]),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.triangle,
                    expression: "!triangle",
                  },
                ],
                staticClass: "triangle-style",
              },
              _vm._l(_vm.storArr, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "triangle-or",
                    style:
                      _vm.queryPageData.data.firstSort === item.value
                        ? "color:rgb(225,86,87);"
                        : "",
                    on: {
                      click: function ($event) {
                        return _vm.firstSortClick(item)
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(item.text))]),
                    _c("van-icon", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.queryPageData.data.firstSort === item.value,
                          expression:
                            "queryPageData.data.firstSort === item.value",
                        },
                      ],
                      attrs: { name: "success", color: "rgb(225,86,87)" },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ],
          1
        ),
        _vm.searchRecordList.length > 0
          ? _c(
              "div",
              { staticClass: "div-record" },
              [
                _vm._l(_vm.searchRecordList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticStyle: {
                        width: "80%",
                        padding: "0px 10%",
                        "text-align": "left",
                        "line-height": "30px",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.searchRecord(item)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(item.searchKey) + " ")]
                  )
                }),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "100%",
                      "text-align": "center",
                      color: "#0082BB",
                      height: "30px",
                      "line-height": "30px",
                    },
                  },
                  [_vm._v("历史搜索记录")]
                ),
              ],
              2
            )
          : _vm._e(),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.searchShowDiv,
                expression: "searchShowDiv",
              },
            ],
            staticClass: "div-subejc",
          },
          [
            _c("van-cell", { attrs: { title: "油漆品牌", border: false } }),
            _c(
              "van-row",
              [
                _c("van-col", { attrs: { span: "1" } }),
                _c("van-col", { attrs: { span: "22" } }, [
                  _c(
                    "div",
                    { staticClass: "col-div" },
                    _vm._l(_vm.paintArr, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "div-cell",
                          style:
                            _vm.queryPageData.data.paintBrandCode ===
                            item.brandCode
                              ? "color:rgb(0,132,184);border: solid 1px rgb(204,230,241);background-color:rgb(204,230,241);"
                              : "",
                          on: {
                            click: function ($event) {
                              return _vm.colCick(item)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "fontSize13" }, [
                            _vm._v(_vm._s(item.brandName)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _c("van-col", { attrs: { span: "1" } }),
              ],
              1
            ),
            _c("van-cell", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.collapseShow,
                  expression: "collapseShow",
                },
              ],
              attrs: { title: "汽车品牌", "is-link": "" },
              scopedSlots: _vm._u([
                {
                  key: "right-icon",
                  fn: function () {
                    return [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticStyle: { display: "block", float: "right" },
                            on: {
                              click: function ($event) {
                                _vm.carBrandShow = true
                              },
                            },
                          },
                          [
                            _c("van-icon", {
                              staticStyle: { "margin-left": "4px" },
                              attrs: {
                                name: "arrow-down",
                                color: "#969799",
                                size: "16",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.recipeAddData.carBrandName
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "block",
                                  float: "right",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.delClick("car_brand")
                                  },
                                },
                              },
                              [
                                _c("van-icon", {
                                  staticClass: "collapse-icon",
                                  attrs: {
                                    color: "red",
                                    size: "20",
                                    name: "cross",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "van-cell__value",
                            staticStyle: { display: "block", float: "right" },
                            on: {
                              click: function ($event) {
                                _vm.carBrandShow = true
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.recipeAddData.carBrandName) + "     "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c(
              "van-popup",
              {
                staticClass: "popup-style",
                attrs: { round: "", position: "bottom" },
                model: {
                  value: _vm.carBrandShow,
                  callback: function ($$v) {
                    _vm.carBrandShow = $$v
                  },
                  expression: "carBrandShow",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "cascader-input-style van-field__controls" },
                  [
                    _c("van-field", {
                      staticClass: "stepper-div-btns",
                      attrs: {
                        "left-icon": "search",
                        type: "search",
                        placeholder: "查询汽车品牌",
                      },
                      model: {
                        value: _vm.carBrandValue,
                        callback: function ($$v) {
                          _vm.carBrandValue = $$v
                        },
                        expression: "carBrandValue",
                      },
                    }),
                  ],
                  1
                ),
                _c("van-cascader", {
                  attrs: {
                    title: "请选择汽车品牌",
                    "active-color": "#1989fa",
                    options: _vm.filterCarBrand,
                  },
                  on: {
                    close: function ($event) {
                      _vm.carBrandShow = false
                    },
                    finish: _vm.onCarBrandFinish,
                  },
                  model: {
                    value: _vm.selectedBrandValue,
                    callback: function ($$v) {
                      _vm.selectedBrandValue = $$v
                    },
                    expression: "selectedBrandValue",
                  },
                }),
              ],
              1
            ),
            _c("van-cell", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.collapseShow,
                  expression: "collapseShow",
                },
              ],
              attrs: { title: "车型", "is-link": "" },
              scopedSlots: _vm._u([
                {
                  key: "right-icon",
                  fn: function () {
                    return [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticStyle: { display: "block", float: "right" },
                            on: { click: _vm.clickCarModel },
                          },
                          [
                            _c("van-icon", {
                              staticStyle: { "margin-left": "4px" },
                              attrs: {
                                name: "arrow-down",
                                color: "#969799",
                                size: "16",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.recipeAddData.carModelName
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "block",
                                  float: "right",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.delClick("car_model")
                                  },
                                },
                              },
                              [
                                _c("van-icon", {
                                  staticClass: "collapse-icon",
                                  attrs: {
                                    color: "red",
                                    size: "20",
                                    name: "cross",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "van-cell__value",
                            staticStyle: { display: "block", float: "right" },
                            on: { click: _vm.clickCarModel },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.recipeAddData.carModelName) + "     "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c(
              "van-popup",
              {
                staticClass: "popup-style",
                attrs: { round: "", position: "bottom" },
                model: {
                  value: _vm.carModelShow,
                  callback: function ($$v) {
                    _vm.carModelShow = $$v
                  },
                  expression: "carModelShow",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "cascader-input-style van-field__controls" },
                  [
                    _c("van-field", {
                      staticClass: "stepper-div-btns",
                      attrs: {
                        "left-icon": "search",
                        type: "search",
                        placeholder: "查询车型",
                      },
                      model: {
                        value: _vm.carModelValue,
                        callback: function ($$v) {
                          _vm.carModelValue = $$v
                        },
                        expression: "carModelValue",
                      },
                    }),
                  ],
                  1
                ),
                _c("van-cascader", {
                  attrs: {
                    title: "请选择车型",
                    "active-color": "#1989fa",
                    options: _vm.filterCarModel,
                  },
                  on: {
                    close: function ($event) {
                      _vm.carModelShow = false
                    },
                    finish: _vm.onCarModelFinish,
                  },
                  model: {
                    value: _vm.selectedModelValue,
                    callback: function ($$v) {
                      _vm.selectedModelValue = $$v
                    },
                    expression: "selectedModelValue",
                  },
                }),
              ],
              1
            ),
            _c("van-cell", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.collapseShow,
                  expression: "collapseShow",
                },
              ],
              attrs: { title: "车色号", "is-link": "" },
              scopedSlots: _vm._u([
                {
                  key: "right-icon",
                  fn: function () {
                    return [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticStyle: { display: "block", float: "right" },
                            on: { click: _vm.colorSizeClick },
                          },
                          [
                            _c("van-icon", {
                              staticStyle: { "margin-left": "4px" },
                              attrs: {
                                name: "arrow-down",
                                color: "#969799",
                                size: "16",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.fieldValue1
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "block",
                                  float: "right",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.delClick("color_code")
                                  },
                                },
                              },
                              [
                                _c("van-icon", {
                                  staticClass: "collapse-icon",
                                  attrs: {
                                    color: "red",
                                    size: "20",
                                    name: "cross",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "van-cell__value",
                            staticStyle: { display: "block", float: "right" },
                            on: { click: _vm.colorSizeClick },
                          },
                          [_vm._v(_vm._s(_vm.fieldValue1) + "     ")]
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c(
              "van-popup",
              {
                staticClass: "popup-style",
                attrs: { round: "", position: "bottom" },
                model: {
                  value: _vm.show1,
                  callback: function ($$v) {
                    _vm.show1 = $$v
                  },
                  expression: "show1",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "cascader-input-style van-field__controls" },
                  [
                    _c("van-field", {
                      staticClass: "stepper-div-btns",
                      attrs: {
                        "left-icon": "search",
                        type: "search",
                        placeholder: "查询车色号",
                      },
                      model: {
                        value: _vm.iptValue,
                        callback: function ($$v) {
                          _vm.iptValue = $$v
                        },
                        expression: "iptValue",
                      },
                    }),
                  ],
                  1
                ),
                _c("van-cascader", {
                  attrs: {
                    title: "请选择车色号",
                    "active-color": "#1989fa",
                    options: _vm.searchResult,
                  },
                  on: {
                    close: function ($event) {
                      _vm.show1 = false
                    },
                    finish: _vm.onFinish1,
                    change: _vm.optionsChange1,
                  },
                  model: {
                    value: _vm.cascaderValue1,
                    callback: function ($$v) {
                      _vm.cascaderValue1 = $$v
                    },
                    expression: "cascaderValue1",
                  },
                }),
              ],
              1
            ),
            _c("van-cell", {
              attrs: { title: "年款", "is-link": "" },
              scopedSlots: _vm._u([
                {
                  key: "right-icon",
                  fn: function () {
                    return [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticStyle: { display: "block", float: "right" },
                            on: { click: _vm.yearClick },
                          },
                          [
                            _c("van-icon", {
                              staticStyle: { "margin-left": "4px" },
                              attrs: {
                                name: "arrow-down",
                                color: "#969799",
                                size: "16",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.recipeAddData.recipeYear
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "block",
                                  float: "right",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.delClick("model_year")
                                  },
                                },
                              },
                              [
                                _c("van-icon", {
                                  staticClass: "collapse-icon",
                                  attrs: {
                                    color: "red",
                                    size: "20",
                                    name: "cross",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "van-cell__value",
                            staticStyle: { display: "block", float: "right" },
                            on: { click: _vm.yearClick },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.recipeAddData.recipeYear) + "     "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c("van-cell", {
              attrs: { title: "适用车龄", "is-link": "" },
              scopedSlots: _vm._u([
                {
                  key: "right-icon",
                  fn: function () {
                    return [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticStyle: { display: "block", float: "right" },
                            on: { click: _vm.vehicleClick },
                          },
                          [
                            _c("van-icon", {
                              staticStyle: { "margin-left": "4px" },
                              attrs: {
                                name: "arrow-down",
                                color: "#969799",
                                size: "16",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.recipeAddData.carAgeDesc
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "block",
                                  float: "right",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.delClick("applicable_car_age")
                                  },
                                },
                              },
                              [
                                _c("van-icon", {
                                  staticClass: "collapse-icon",
                                  attrs: {
                                    color: "red",
                                    size: "20",
                                    name: "cross",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "van-cell__value",
                            staticStyle: { display: "block", float: "right" },
                            on: { click: _vm.vehicleClick },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.recipeAddData.carAgeDesc) + "     "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c(
              "van-popup",
              {
                style: { height: "38%" },
                attrs: { position: "bottom", round: "" },
                model: {
                  value: _vm.pickerVehicleShow,
                  callback: function ($$v) {
                    _vm.pickerVehicleShow = $$v
                  },
                  expression: "pickerVehicleShow",
                },
              },
              [
                _c("van-picker", {
                  attrs: {
                    title: "选择车龄",
                    "show-toolbar": "",
                    "default-index": "1",
                    columns: _vm.vehicleColumns,
                  },
                  on: {
                    confirm: _vm.vehicleOnConfirm,
                    cancel: _vm.vehicleOnCancel,
                  },
                }),
              ],
              1
            ),
            _c("van-cell", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.collapseShow,
                  expression: "collapseShow",
                },
              ],
              attrs: {
                title: "上传地域",
                "is-link": "",
                "arrow-direction": "down",
              },
              scopedSlots: _vm._u([
                {
                  key: "right-icon",
                  fn: function () {
                    return [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticStyle: { display: "block", float: "right" },
                            on: { click: _vm.territoryClick },
                          },
                          [
                            _c("van-icon", {
                              staticStyle: { "margin-left": "4px" },
                              attrs: {
                                name: "arrow-down",
                                color: "#969799",
                                size: "16",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.recipeAddData.uploadRegionName
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "block",
                                  float: "right",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.delClick("upload_location")
                                  },
                                },
                              },
                              [
                                _c("van-icon", {
                                  staticClass: "collapse-icon",
                                  attrs: {
                                    color: "red",
                                    size: "20",
                                    name: "cross",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "van-cell__value",
                            staticStyle: { display: "block", float: "right" },
                            on: { click: _vm.territoryClick },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.recipeAddData.uploadRegionName) +
                                "     "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c(
              "van-popup",
              {
                style: { height: "38%" },
                attrs: { position: "bottom", round: "" },
                model: {
                  value: _vm.pickerTerritoryShow,
                  callback: function ($$v) {
                    _vm.pickerTerritoryShow = $$v
                  },
                  expression: "pickerTerritoryShow",
                },
              },
              [
                _c("van-picker", {
                  attrs: {
                    title: "选择省份",
                    "show-toolbar": "",
                    "default-index": "1",
                    columns: _vm.TerritoryColumns,
                  },
                  on: {
                    confirm: _vm.TerritoryOnConfirm,
                    cancel: _vm.TerritoryOnCancel,
                  },
                }),
              ],
              1
            ),
            _c(
              "van-collapse",
              {
                attrs: { accordion: "" },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _c(
                  "van-collapse-item",
                  {
                    attrs: {
                      title: "配方分类",
                      value: _vm.queryPageData.data.recipeTypesValue,
                      name: "0",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "value",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.queryPageData.data.recipeTypesValue
                                  ) + "     "
                                ),
                                _vm.queryPageData.data.recipeTypesValue
                                  ? _c("van-icon", {
                                      staticClass: "collapse-icon",
                                      attrs: {
                                        color: "red",
                                        size: "20",
                                        name: "cross",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.delClick("recipe_type")
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "div-subejc-box-recipe" },
                      _vm._l(_vm.formulaTypeArr, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "div-subejc-div",
                            style:
                              _vm.queryPageData.data.recipeTypes[0] === item.val
                                ? "color:rgb(0,132,184);border: solid 1px rgb(204,230,241);background-color:rgb(204,230,241);"
                                : "",
                            on: {
                              click: function ($event) {
                                return _vm.pfClick(item)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(item.lab) + " ")]
                        )
                      }),
                      0
                    ),
                  ]
                ),
                _c(
                  "van-collapse-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.collapseShow,
                        expression: "collapseShow",
                      },
                    ],
                    attrs: {
                      value: _vm.queryPageData.data.colorGroupValue,
                      title: "颜色组别",
                      name: "1",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "value",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.queryPageData.data.colorGroupValue
                                  ) + "     "
                                ),
                                _vm.queryPageData.data.colorGroupValue
                                  ? _c("van-icon", {
                                      staticClass: "collapse-icon",
                                      attrs: {
                                        color: "red",
                                        size: "20",
                                        name: "cross",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.delClick("color_group")
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "div-subejc-box" },
                      _vm._l(_vm.colorArrs, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "div-subejc-div",
                            style:
                              _vm.queryPageData.data.colorGroup === item.itemKey
                                ? "color:rgb(0,132,184);border: solid 1px rgb(204,230,241);background-color:rgb(204,230,241);"
                                : "",
                            on: {
                              click: function ($event) {
                                return _vm.ysClick(item)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(item.itemValue) + " ")]
                        )
                      }),
                      0
                    ),
                  ]
                ),
                _c(
                  "van-collapse-item",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.collapseShow,
                        expression: "collapseShow",
                      },
                    ],
                    attrs: {
                      value: _vm.queryPageData.data.colorSpecialValue,
                      title: "颜色效果",
                      name: "2",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "value",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.queryPageData.data.colorSpecialValue
                                  ) + "     "
                                ),
                                _vm.queryPageData.data.colorSpecialValue
                                  ? _c("van-icon", {
                                      staticClass: "collapse-icon",
                                      attrs: {
                                        color: "red",
                                        size: "20",
                                        name: "cross",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.delClick("color_effects")
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "div-subejc-box" },
                      _vm._l(_vm.colorSpecialArr, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "div-subejc-div",
                            style:
                              _vm.queryPageData.data.colorSpecial ===
                              item.itemKey
                                ? "color:rgb(0,132,184);border: solid 1px rgb(204,230,241);background-color:rgb(204,230,241);"
                                : "",
                            on: {
                              click: function ($event) {
                                return _vm.txClick(item)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(item.itemValue) + " ")]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.collapseShow,
                    expression: "!collapseShow",
                  },
                ],
                staticClass: "BtnStyle",
                on: { click: _vm.prickerFewClick1 },
              },
              [_c("span", [_vm._v("更多")])]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.collapseShow,
                    expression: "collapseShow",
                  },
                ],
                staticClass: "BtnStyle",
                on: { click: _vm.prickerMoreClick },
              },
              [_c("span", [_vm._v("收起")])]
            ),
            _c("div", { staticStyle: { "margin-top": "50px" } }),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.searchShowDiv,
                expression: "!searchShowDiv",
              },
            ],
            staticClass: "search-dev",
          },
          [
            _c(
              "van-list",
              {
                attrs: {
                  finished: _vm.finished,
                  "finished-text":
                    _vm.recipeOrder.list.length == 0
                      ? "没有匹配结果"
                      : "没有更多了",
                },
                on: { load: _vm.onLoad },
                model: {
                  value: _vm.loading,
                  callback: function ($$v) {
                    _vm.loading = $$v
                  },
                  expression: "loading",
                },
              },
              _vm._l(_vm.recipeOrder.list, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "order-box",
                    on: {
                      click: function ($event) {
                        return _vm.orderClick(item)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "div-box-txt" }, [
                      _c("div", { staticClass: "d1" }, [
                        _c("div", {
                          staticClass: "d1-title1",
                          style:
                            item.colorSpecial != 10071004
                              ? "background-color:" +
                                item.colorRgb +
                                ";background-image: linear-gradient(" +
                                item.gcColorRgb +
                                "," +
                                item.colorRgb +
                                "," +
                                item.colorRgb +
                                "," +
                                item.gcColorRgb +
                                ")"
                              : "background-color:" + item.colorRgb,
                        }),
                        _c("div", { staticClass: "d1-title2" }, [
                          _c(
                            "div",
                            { staticClass: "d1-title1-txt1" },
                            [
                              _c(
                                "van-row",
                                { attrs: { justify: "end" } },
                                [
                                  _c("van-col", { staticClass: "env-col" }),
                                  _c(
                                    "van-col",
                                    {
                                      staticStyle: { display: "flex" },
                                      attrs: { span: "15" },
                                    },
                                    [
                                      _c("div", { staticClass: "txt-span" }, [
                                        _vm._v(
                                          _vm._s(item.colorCode) +
                                            " " +
                                            _vm._s(item.colorName)
                                        ),
                                      ]),
                                      item.collectionTime == null
                                        ? _c("van-icon", {
                                            attrs: {
                                              size: "1.2rem",
                                              color: "rgb(204,204,204)",
                                              name: "star",
                                            },
                                          })
                                        : _c("van-icon", {
                                            attrs: {
                                              size: "1.2rem",
                                              color: "rgb(254,200,9)",
                                              name: "star",
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "van-col",
                                    {
                                      staticStyle: { blackgroun: "red" },
                                      attrs: { span: "8" },
                                    },
                                    [
                                      item.paintBrandCode === "NBW" ||
                                      item.paintBrandCode === "NBS1K" ||
                                      item.paintBrandCode === "NBS2K"
                                        ? _c("img", {
                                            staticClass: "img-log",
                                            attrs: {
                                              src: require("../assets/image/brand2.png"),
                                              alt: "",
                                            },
                                          })
                                        : _c("img", {
                                            staticClass: "img-log",
                                            attrs: {
                                              src: require("../assets/image/brand1.png"),
                                              alt: "",
                                            },
                                          }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "van-row",
                                [
                                  _c("van-col", { attrs: { span: "24" } }, [
                                    item.avgScore > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          },
                                          [
                                            _vm._l(
                                              _vm.commentLevelImg[index],
                                              function (item, index) {
                                                return _c("img", {
                                                  key: index,
                                                  staticClass: "img-styles",
                                                  attrs: {
                                                    src: item.url,
                                                    alt: "",
                                                  },
                                                })
                                              }
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  margin: "1px 0 0 8px",
                                                  "font-size": "13px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.avgScore) + "分"
                                                ),
                                              ]
                                            ),
                                          ],
                                          2
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  margin: "1px 0 0",
                                                  "font-size": "13px",
                                                },
                                              },
                                              [_vm._v("暂无评分")]
                                            ),
                                          ]
                                        ),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "div-end" }, [
                                _c("div", { staticClass: "end-d1" }, [
                                  _c("div", { staticClass: "icon-circle" }, [
                                    _c(
                                      "span",
                                      { staticClass: "icon-circle-class" },
                                      [_vm._v(_vm._s(item.recipeLabel))]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "icon-circleTwo" }, [
                                    _c(
                                      "span",
                                      { staticClass: "icon-circle-class" },
                                      [_vm._v(_vm._s(item.paintBrandLabel))]
                                    ),
                                  ]),
                                  item.collectionCount > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "icon-circleThree" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "icon-circle-class",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(item.collectionCount) +
                                                  "次收藏"
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _c("div", { staticClass: "end-preview" }, [
                                  item.photo === null || item.photo === ""
                                    ? _c(
                                        "div",
                                        { staticClass: "icon-imgs-style" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "13px",
                                                color: "rgb(0,145,220)",
                                              },
                                            },
                                            [_vm._v("暂无图片")]
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "icon-imgs-style",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.imgClick(item)
                                            },
                                          },
                                        },
                                        [
                                          _c("van-icon", {
                                            attrs: { name: "photo-o" },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "13px",
                                                color: "rgb(0,145,220)",
                                                padding: "0px 3px",
                                              },
                                              attrs: {
                                                color: "rgb(0,145,220)",
                                              },
                                            },
                                            [_vm._v(" 预览 ")]
                                          ),
                                          _c("div", {
                                            attrs: { id: "triangle-right" },
                                          }),
                                        ],
                                        1
                                      ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "d2" },
                        [
                          _c(
                            "van-row",
                            { staticClass: "van-rows" },
                            [
                              _c("van-col", {
                                staticClass: "env-col",
                                attrs: { span: "2" },
                              }),
                              _c("van-col", { attrs: { span: "20" } }, [
                                _c("div", { staticClass: "span-h3-box" }, [
                                  _c("img", {
                                    staticStyle: {
                                      height: "1.3rem",
                                      position: "relative",
                                      top: "3px",
                                    },
                                    attrs: {
                                      src: require("../assets/image/vehicleIcon.png"),
                                      alt: "",
                                    },
                                  }),
                                  _c("span", { staticClass: "span-h3" }, [
                                    _vm._v(
                                      _vm._s(item.carBrandName) +
                                        " - " +
                                        _vm._s(item.carModelName)
                                    ),
                                  ]),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "van-row",
                            { staticClass: "van-rows" },
                            [
                              _c("van-col", {
                                staticClass: "env-col",
                                attrs: { span: "2" },
                              }),
                              _c("van-col", { attrs: { span: "12" } }, [
                                _c("span", { staticClass: "span-min" }, [
                                  _vm._v("上传时间　"),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "0.7rem",
                                        "margin-top": ".1rem",
                                        color: "black",
                                      },
                                    },
                                    [_vm._v(_vm._s(item.uploadTimeStr))]
                                  ),
                                ]),
                              ]),
                              _c("van-col", { attrs: { span: "8" } }, [
                                _c("div", [
                                  _c("span", { staticClass: "span-min" }, [
                                    _vm._v("上传地域　"),
                                    item.uploadRegionName === ""
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "0.7rem",
                                              "margin-top": ".1rem",
                                              color: "black",
                                            },
                                          },
                                          [_vm._v("通用")]
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "0.7rem",
                                              "margin-top": ".1rem",
                                              color: "black",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.uploadRegionName)
                                            ),
                                          ]
                                        ),
                                  ]),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _c("van-row"),
                          _c(
                            "van-row",
                            { staticClass: "van-rows" },
                            [
                              _c("van-col", {
                                staticClass: "env-col",
                                attrs: { span: "2" },
                              }),
                              _c("van-col", { attrs: { span: "12" } }, [
                                _c("span", { staticClass: "span-min" }, [
                                  _vm._v("适用车龄　"),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "0.7rem",
                                        "margin-top": ".1rem",
                                        color: "black",
                                      },
                                    },
                                    [_vm._v(_vm._s(item.carAgeDesc))]
                                  ),
                                ]),
                              ]),
                              _c("van-col", { attrs: { span: "8" } }, [
                                _c("span", { staticClass: "span-min" }, [
                                  _vm._v("车型年款　"),
                                  _c("span", { staticClass: "span-colorOne" }, [
                                    _vm._v(_vm._s(item.recipeYear)),
                                  ]),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "van-row",
                            { staticClass: "van-rows" },
                            [
                              _c("van-col", {
                                staticClass: "env-col",
                                attrs: { span: "2" },
                              }),
                              _c("van-col", { attrs: { span: "12" } }, [
                                _c("span", { staticClass: "span-min" }, [
                                  _vm._v("调漆工序　"),
                                  _c("span", { staticClass: "span-colorOne" }, [
                                    _vm._v(
                                      _vm._s(
                                        item.isThree == 1 ? "多工序" : "单工序"
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                              _c("van-col", { attrs: { span: "8" } }, [
                                _c("span", { staticClass: "span-min" }, [
                                  _vm._v("偏差描述　"),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "0.7rem",
                                        "margin-top": ".1rem",
                                        color: "black",
                                      },
                                    },
                                    [_vm._v(_vm._s(item.deviantColor))]
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
      ]),
      _c(
        "van-popup",
        {
          style: { height: "38%" },
          attrs: { position: "bottom", round: "" },
          model: {
            value: _vm.pickerShow,
            callback: function ($$v) {
              _vm.pickerShow = $$v
            },
            expression: "pickerShow",
          },
        },
        [
          _c("van-picker", {
            attrs: {
              title: "选择位置",
              "show-toolbar": "",
              "default-index": "1",
              columns: _vm.columns,
            },
            on: { confirm: _vm.onConfirm, cancel: _vm.onCancel },
          }),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          style: { height: "38%" },
          attrs: { position: "bottom", round: "" },
          model: {
            value: _vm.pickerShow1,
            callback: function ($$v) {
              _vm.pickerShow1 = $$v
            },
            expression: "pickerShow1",
          },
        },
        [
          _c("van-picker", {
            attrs: {
              title: "选择年款",
              "show-toolbar": "",
              "default-index": "1",
              columns: _vm.columnsN,
            },
            on: { confirm: _vm.onConfirm, cancel: _vm.onCancelss },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "searchBtn" }, [
        _c(
          "div",
          { staticClass: "searchBtn-d2" },
          [
            _c(
              "van-button",
              {
                attrs: { round: "", type: "info" },
                on: { click: _vm.resetSearch },
              },
              [_vm._v("重置")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "searchBtn-d1" },
          [
            _c(
              "van-button",
              {
                staticClass: "top",
                attrs: { round: "", type: "info" },
                on: { click: _vm.searchDivClick },
              },
              [_vm._v("搜索")]
            ),
          ],
          1
        ),
      ]),
      _c("van-image-preview", {
        attrs: { images: _vm.images },
        on: { change: _vm.onChange },
        model: {
          value: _vm.showImg,
          callback: function ($$v) {
            _vm.showImg = $$v
          },
          expression: "showImg",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }